type Translate = (key: string, options?: Record<string, unknown>) => string;

/** "Paused - <reason>" for a step paused with a reason, otherwise the plain "Order is paused". */
export const pausedLabel = (pauseReason: string | null | undefined, translate: Translate): string =>
    pauseReason
        ? // React escapes the text; i18next escaping would show "&" as "&amp;".
          translate('workflow:ORDER_IS_PAUSED_WITH_REASON', {
              reason: pauseReason,
              interpolation: { escapeValue: false },
          })
        : translate('workflow:ORDER_IS_PAUSED');
